import { createContext } from 'react'

const PlatformContext = createContext()

export default PlatformContext
